class PageSliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.gap = Number(this.dataset.gap || "0")),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(
        ".slider-counter--current",
      )),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton =
        this.querySelector('span[name="previous"]') ||
        this.querySelector('span[name="previous"]')),
      (this.nextButton =
        this.querySelector('span[name="next"]') ||
        this.querySelector('span[name="next"]')),
      !this.slider || !this.nextButton)
    )
      return;
    (this.initPages(),
      new ResizeObserver((entries) => this.initPages()).observe(this.slider),
      this.slider.addEventListener("scroll", this.update.bind(this)),
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this)));
  }
  initPages() {
    ((this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    )),
      (this.sliderLastItem =
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]),
      this.sliderItemsToShow.length !== 0 &&
        ((this.slidesPerPage = Math.floor(
          this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth,
        )),
        (this.totalPages =
          this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update()));
  }
  resetPages() {
    ((this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      this.initPages());
  }
  update() {
    const previousPage = this.currentPage;
    ((this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != previousPage &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        ),
      !this.enableSliderLooping &&
        (this.isSlideVisible(this.sliderItemsToShow[0])
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
        console.log(
          "--this.isSlideVisible(this.sliderLastItem)--",
          this.isSlideVisible(this.sliderLastItem),
        ),
        this.isSlideVisible(this.sliderLastItem, 0, !0)
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled")));
  }
  isSlideVisible(element, offset = 0, isLast) {
    const elRect = element.getBoundingClientRect();
    const sliderRect = this.slider.getBoundingClientRect();
    if (isLast) {
      console.log("--last---", { elRight: elRect.right, sliderRight: sliderRect.right });
      return elRect.right <= sliderRect.right + 1;
    }
    console.log("--first---", { elLeft: elRect.left, sliderLeft: sliderRect.left });
    return elRect.left >= sliderRect.left - 1;
  }
  onButtonClick(event) {
    event.preventDefault();
    const containerWidth = this.slider.clientWidth - 180;
    ((this.slideScrollPosition =
      event.currentTarget.getAttribute("name") === "next"
        ? this.slider.scrollLeft + containerWidth
        : this.slider.scrollLeft - containerWidth),
      this.slider.scrollTo({
        left: this.slideScrollPosition,
        behavior: "smooth",
      }));
  }
}
customElements.define("page-slider-component", PageSliderComponent);

// Fix dropdown banner clipping from overflow-x:auto on the nav slider
// Source: https://stackoverflow.com/a/60912860 — Temani Afif — CC BY-SA 4.0
document.querySelectorAll('page-slider-component .nav-item').forEach((item) => {
  item.addEventListener('mouseover', () => {
    const r = item.getBoundingClientRect();
    item.style.setProperty('--t', r.top + 'px');
    item.style.setProperty('--l', r.left + 'px');
    item.style.setProperty('--w', r.width + 'px');
    item.style.setProperty('--b', r.bottom + 'px');
  });
});

/* START hamburger drawer accordion
   Replaces the theme's drill-down (sliding layered panels) mobile menu with
   inline expandable accordion items. The markup in snippets/hamberger-drawer.liquid
   uses <hamburger-accordion-menu> instead of <hamburger-menu> so base.js's
   HamburgerMenu (which animates the panels in from the right) never upgrades it. */
class HamburgerAccordionMenu extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.onClick);
    this.addEventListener("transitionend", this.onTransitionEnd);
    this.boundCollapseAll = this.collapseAll.bind(this);
    if (typeof _EVENT_HELPER !== "undefined") {
      document.addEventListener(_EVENT_HELPER.hideDrawer, this.boundCollapseAll);
    }
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
    this.removeEventListener("transitionend", this.onTransitionEnd);
    if (typeof _EVENT_HELPER !== "undefined") {
      document.removeEventListener(_EVENT_HELPER.hideDrawer, this.boundCollapseAll);
    }
  }

  onClick(event) {
    const button = event.target.closest("[hamberger-menu-item]");
    if (!button || !this.contains(button)) return;
    event.preventDefault();

    const panel = button.nextElementSibling;
    if (!panel || !panel.hasAttribute("hamberger-menu-content")) return;

    if (button.getAttribute("aria-expanded") === "true") {
      this.close(button, panel);
    } else {
      // Only one item open per level, so the drawer stays readable.
      const list = button.closest("ul");
      const siblings = list
        ? list.querySelectorAll(
            ":scope > li > .accordion__item > [hamberger-menu-item][aria-expanded='true']",
          )
        : [];
      siblings.forEach((openButton) => {
        if (openButton !== button) this.close(openButton, openButton.nextElementSibling);
      });
      this.open(button, panel);
    }
  }

  open(button, panel) {
    button.setAttribute("aria-expanded", "true");
    panel.classList.add("active");
    panel.style.maxHeight = panel.scrollHeight + "px";
  }

  close(button, panel) {
    // Pin the current height first so the collapse has something to animate from.
    panel.style.maxHeight = panel.scrollHeight + "px";
    requestAnimationFrame(() => {
      button.setAttribute("aria-expanded", "false");
      panel.classList.remove("active");
      panel.style.maxHeight = "0px";
    });
  }

  onTransitionEnd(event) {
    const panel = event.target;
    if (event.propertyName !== "max-height") return;
    if (!panel.hasAttribute || !panel.hasAttribute("hamberger-menu-content")) return;
    // Release the fixed height while open so nested items can grow the parent.
    if (panel.classList.contains("active")) panel.style.maxHeight = "none";
  }

  collapseAll(event) {
    if (event && event.detail && event.detail.drawerType !== "header") return;
    setTimeout(() => {
      this.querySelectorAll("[hamberger-menu-content]").forEach((panel) => {
        panel.classList.remove("active");
        panel.style.maxHeight = "";
      });
      this.querySelectorAll("[hamberger-menu-item]").forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });
    }, 500);
  }
}
customElements.define("hamburger-accordion-menu", HamburgerAccordionMenu);
/* END hamburger drawer accordion */
